import React, { useEffect, useState } from 'react';
import ReactFullpage from '@fullpage/react-fullpage';
import Logo from '../logo/logo';
import Clock from '../clock/clock';
import './fullpage.css'
import { Link } from 'react-router-dom';
import BackroundVideo from './background video/backgroundVideo';
import { page3Data } from '../page3/page3Data'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import 'swiper/swiper.scss';
import { historyData } from '../page4/historyData';
import ButtonMailto from '../page5/buttonEmail';
import { AiOutlineMail } from "react-icons/ai";
import RingLoader from "react-spinners/RingLoader";


Page1.propTypes = {

};



function Page1(props) {
  SwiperCore.use([Autoplay]);

  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
    }, 3000);
  }, [])

  return (
    
    <div className="cover">
      {
        isLoading ?
          <div className="fullpage-loading">
            <RingLoader color={'#34CEE6'} loading={isLoading} size={150} />
          </div>
          :
          <ReactFullpage
            //fullpage options
            licenseKey={'YOUR_KEY_HERE'}
            scrollingSpeed={800} /* Options here */
            navigation={true}
            resetSliders={false}
            responsiveSlides={true}
            normalScrollElements={".coverHistory"}
            render={() => {
              return (
                <ReactFullpage.Wrapper>
                  <div className="section BgPage1">
                    <BackroundVideo ></BackroundVideo>
                    <div className="container">
                      <div className="cover-content">
                        <Logo />
                        <div className="webTitle">
                          <p>Ken</p>
                          <p>Gaming</p>
                        </div>
                        <div className='viewgame' >
                          <Link to='/works'>View Game</Link>
                        </div>
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className="section page2">
                    <div className="container">
                      <div className="brand-name">
                        <p>ken gaming</p>
                        <p>PHILOSOPHY</p>
                      </div>
                      <div className="content">
                        <p>Dreams come true <br /> Without that possibility
                          ,<br /> Nature would not incite <br /> us to have them.</p>
                      </div>
                    </div>
                  </div>
                  <div className="section page3">
                    <div className="container">
                      <div className="cover-content">
                        <div className="wrapper">
                          {page3Data.map((item, index) => {
                            return (
                              <div className="col" key={index}>
                                <p className="col-title">{item.title}</p>
                                <p className="col-content">{item.content}</p>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="section page4">
                    <div className="container">
                      <div className="cover-history">
                        <div className="title">
                          <p>History</p>
                        </div>
                        <div className="content">
                          <Swiper
                            spaceBetween={0}
                            slidesPerView={4}
                            autoplay={true}

                            breakpoints={{
                              "200": {
                                "slidesPerView": 1,
                              },
                              "500": {
                                "slidesPerView": 2,
                              },
                              "768": {
                                "slidesPerView": 2,
                              },
                              "1024": {
                                "slidesPerView": 3,
                              },
                              "1200": {
                                "slidesPerView": 4,
                              }
                            }}
                          >
                            {historyData.map((item, index) => {
                              return (
                                <SwiperSlide key={index}>
                                  <div className="coverHistory">
                                    <div className="year">
                                      <p>{item.year}</p>
                                    </div>
                                    <div className="historyDetail">
                                      {item.yearData.map((item, index) => {
                                        return (
                                          <div className="detail" key={index}>
                                            <p>{item.content}</p>
                                            <p>{item.motion}</p>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </div>
                                </SwiperSlide>
                              )
                            })}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="section page5">
                    <div className="container">
                      <div className="page5Title">
                        <p>ken gaming</p>
                        <p>creative partners</p>
                      </div>
                      <div className="page5Content">
                        <div className="partnership">
                          <p className="title">Partnerships.</p>
                          <ButtonMailto className="EmailButton" label="kendidang2k@gmail.com" icon={<AiOutlineMail></AiOutlineMail>} mailto="mailto:kendidang2k@gmail.com"></ButtonMailto>
                        </div>
                        <div className="recruiting">
                          <p className="title">Recruiting.</p>
                          <ButtonMailto className="EmailButton" label="kendidang2k@gmail.com" icon={<AiOutlineMail></AiOutlineMail>} mailto="mailto:kendidang2k@gmail.com" />
                        </div>
                        <div className="learnMore">
                          <p className="title">Learn More.</p>
                          <Link to="/" >Learn more about us.</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </ReactFullpage.Wrapper>
              );
            }}
          />
      }

    </div>
  );
}

export default Page1;